import { render, staticRenderFns } from "./sf-editor.vue?vue&type=template&id=f24f19e8&scoped=true&"
import script from "./sf-editor.vue?vue&type=script&lang=ts&"
export * from "./sf-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24f19e8",
  null
  
)

export default component.exports